import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import jwt from "jsonwebtoken";
import $ from "jquery";
axios.defaults.headers.common["cache-control"] = "no-cache";
var qs = require("qs");
Vue.use(Vuex);

const state = {
  isLogin: false,
  user: null,
  token: null,
  tokens: null,
};

const getters = {
  isLogin: (state) => {
    return state.isLogin;
  },
  user: (state) => {
    return state.user;
  },
  token: (state) => {
    return state.token;
  },
  tokens: (state) => {
    return state.tokens;
  },
};

const mutations = {
  isLogin: (state, payload) => {
    state.isLogin = payload;
  },
  user: (state, payload) => {
    state.user = payload;
  },
  token: (state, payload) => {
    state.token = payload;
  },
  tokens: (state, payload) => {
    state.tokens = payload;
  },
};
const actions = {
  callApiMotherFucker: ({ state }, payload) => {
    $(".preloader").show();
    return new Promise((resolve, reject) => {
      let bodyData = jwt.sign(
        payload.data,
        "b7FI6NEBr9l29f1iGPWwcQtuR4bLUEL8W2E8lfUiPI0qwgvuiruf",
        {
          expiresIn: "999999999s",
        }
      );
      var data = qs.stringify({
        token: bodyData,
      });

      var config = {
        method: payload.method,
        url: "https://sms-fast.warmlight.online/api" + payload.path,
        headers: {
          Authorization: "Bearer " + state.tokens,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
      };

      axios(config)
        .then(function(response) {
          resolve(response.data);
          setTimeout(() => {
            $(".preloader").hide();
          }, 100);
          // console.log(JSON.stringify(response.data))
        })
        .catch(function(error) {
          reject(error);
          // if (error.code == 2130) {
          // 	localStorage.setItem('tokens', null)
          // 	console.log(localStorage.getItem('tokens'))
          // 	this.$router.push('/login')
          // }

          setTimeout(() => {
            $(".preloader").hide();
          }, 100);
        });
    });
  },
  login: ({ commit }, payload) => {
    commit("isLogin", true);

    let auth = {
      headers: {
        Authorization: "Bearer " + payload,
      },
    };

    commit("tokens", payload);
    localStorage.setItem("tokens", payload);
    localStorage.setItem("timeout", new Date().getTime() + 1 * 60 * 60 * 1000);
    commit("token", auth);
    let user = jwt.decode(payload);
    if (user) {
      commit("user", user.results[0]);
      // Axios.get(apiservice + '/amount',
      //   state.token).then(respon => {
      //     commit('amount', respon.data)
      //   })
    }
  },
  loadsession: ({ commit }) => {
    let tokens = localStorage.getItem("tokens");
    if (new Date().getTime() <= localStorage.getItem("timeout")) {
      var config = {
        method: "GET",
        url: "https://sms-fast.warmlight.online/api/is_login",
        headers: {
          Authorization: "Bearer " + tokens,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: {},
      };

      axios(config)
        .then(function(response) {
          if (response.data.code == "undefined" || response.data.code === 1) {
            commit("isLogin", false);
            window.location.href = "/Logout";
          } else {
            commit("isLogin", true);
            let auth = {
              headers: {
                Authorization: "Bearer " + response.data,
              },
            };
            commit("tokens", response.data);
            commit("token", auth);
            let user = jwt.decode(response.data);
            if (user) {
              commit("user", user.results[0]);
            }
          }
          localStorage.setItem("tokens", response.data);
        })
        .catch(function(error) {
          window.location.href = "/Logout";
          console.log(error);
        });
    
    
      } else {
      commit("isLogin", false);
      window.location.href = "/Logout";
    }
  },
  logout: ({ commit }) => {
    localStorage.removeItem("tokens");
    commit("isLogin", false);
    commit("user", null);
    commit("token", null);
  },
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
});
